import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Sourcefounding, SourcefoundingDTO } from '../../models/sourcefounding.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { RequestService } from '../request/request';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class SourcefoundingService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'source-foundings/';
  url = environment.service_1 + 'all-source-foundings/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedsourcefounding = new BehaviorSubject<Sourcefounding | null>(null);
  selectedsourcefounding$ = this.selectedsourcefounding.asObservable();

  private foundingsources = new BehaviorSubject<Sourcefounding[]>([]);
  foundingsources$ = this.foundingsources.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setSourcefounding(sourcefounding: Sourcefounding) {
    this.selectedsourcefounding.next(sourcefounding);
  }

  setfoundingsources(foundingsources: Sourcefounding[]) {
    this.foundingsources.next(foundingsources);
  }

  removeSourcefoundingSelected() {
    this.selectedsourcefounding.next(null);
  }

  createSourcefounding(sourcefounding: SourcefoundingDTO) {
    return this.http.post<Sourcefounding>(this.urlPath, sourcefounding).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateSourcefounding(id: number, sourcefounding: SourcefoundingDTO & { id: number }) {
    return this.http.put<Sourcefounding>(this.urlPath + id + '/', sourcefounding).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getFoundingsources(query: QueryGet): Observable<Pagination<Sourcefounding[]>> {
    return this.requestService.get<Sourcefounding[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getFoundingsource(): Observable<Sourcefounding[]> {
    return this.http.get<Sourcefounding[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionFoundingsources(component: Sourcefounding[]): OptionSelect[] {
    return component.map((item: Sourcefounding) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
